/*
 * Right in – logo og ordmerke
 * Slagord: "Enklere billettering" (EN: "Simplified ticketing")
 * Mark: pil som går rett inn gjennom en døråpning – "Right in".
 */

export const LogoMark = ({ className = "w-9 h-9" }) => (
  <svg viewBox="0 0 48 48" className={className} role="img" aria-label="Right in logo" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="48" height="48" rx="14" fill="hsl(222 47% 11%)" />
    <path
      d="M27.5 11.5h7a3.5 3.5 0 0 1 3.5 3.5v18a3.5 3.5 0 0 1-3.5 3.5h-7"
      stroke="hsl(210 40% 98%)"
      strokeWidth="3.2"
      strokeLinecap="round"
    />
    <path d="M8.5 24h17" stroke="hsl(186 72% 48%)" strokeWidth="3.4" strokeLinecap="round" />
    <path
      d="M19.5 17.5 26 24l-6.5 6.5"
      stroke="hsl(186 72% 48%)"
      strokeWidth="3.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const LogoWordmark = ({ className = "text-lg", light = false }) => (
  <span className={`font-heading font-semibold tracking-tight whitespace-nowrap ${light ? "text-primary-foreground" : "text-foreground"} ${className}`}>
    Right<span className="text-brand"> in</span>
  </span>
);

export const Logo = ({ markClassName = "w-9 h-9", textClassName = "text-lg", light = false, showTagline = false, taglineClassName = "" }) => (
  <span className="flex items-center gap-2.5">
    <LogoMark className={markClassName} />
    <span className="flex flex-col leading-none gap-0.5">
      <LogoWordmark className={textClassName} light={light} />
      {showTagline && (
        <span className={`text-[11px] whitespace-nowrap ${light ? "text-primary-foreground/70" : "text-muted-foreground"} ${taglineClassName}`}>
          Enklere billettering
        </span>
      )}
    </span>
  </span>
);
